/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Resource search request
*/
export class SearchResourcesRequest {
  /**
  * The search query text
  */
  'queryText': string;
  /**
  * Keywords for keyword search (parallel with semantic)
  */
  'tags'?: Array<string>;
  /**
  * Optional list of resource IDs to filter the search by
  */
  'resourceIds'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "queryText",
      "baseName": "query_text",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "resourceIds",
      "baseName": "resource_ids",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchResourcesRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

